import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { GetBoxesOutput } from "types/web-app";

export const getBoxes = async (accessToken: string) => {
  try {
    const response = await fetchWithAuth("/box/list", accessToken);
    const data = (await response.json()) as ServiceResponse<GetBoxesOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
